/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ISaveStatus } from '../models/ISaveStatus';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class PatientPortalAccessRequestService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param patientId
     * @returns string
     * @throws ApiError
     */
    public patientPortalAccessRequestGetByPatientId(
        patientId: number,
    ): Observable<string> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/accessRequests/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns ISaveStatus
     * @throws ApiError
     */
    public patientPortalAccessRequestSendEmailInvitationToPatientPortal(
        patientId: number,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/accessRequests/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns ISaveStatus
     * @throws ApiError
     */
    public patientPortalAccessRequestDeleteByPatientId(
        patientId: number,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/accessRequests/{patientId}',
            path: {
                'patientId': patientId,
            },
        });
    }
    /**
     * @param patientId
     * @returns ISaveStatus
     * @throws ApiError
     */
    public patientPortalAccessRequestRevokePatientPortalAccess(
        patientId: number,
    ): Observable<ISaveStatus> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/accessRequests/{patientId}/revoke',
            path: {
                'patientId': patientId,
            },
        });
    }
}
